export default class ExtranetServicesIndex {
  constructor() {
    this.filters = {
      steps: [],
      customer: '',
      query: ''
    };
    this.searchTimeout = null;
    // Remember which options were checked when the list refreshes
    this.pendingOptionSelection = null;
    // Avoid spamming the user with repeated warnings when preventing invalid changes
    this.optionRemovalWarningShown = false;
    this.optionAdditionWarningShown = false;

    this.bindEvents();

    this.filters.steps = this.step_filter ? this.step_filter.val() || [] : [];

    const initialCustomer = $('#customer-filter').val();
    this.filters.customer = initialCustomer ? initialCustomer.toString() : '';

    const initialQuery = $('#service_customSearch').val();
    this.filters.query = initialQuery ? initialQuery.toString().trim() : '';

    this.initDataTable();
  }

  bindEvents() {
    this.step_filter = $("#service-step-filter");
    
    if (!this.step_filter.hasClass('select2-hidden-accessible')) {
      this.step_filter.select2({
        multiple: true,
        placeholder: "Sélectionner des états",
        allowClear: true,
        closeOnSelect: false,
      });
    }
    
    // Leave default selection provided by server (e.g. 'En service')
  }

  initDataTable() {
    const table = $('#services-table');
    
    if (table.length === 0) return;

    const sourceUrl = table.data('source-url');
    const localeUrl = table.data('locale-url');

    if (!sourceUrl) {
      return;
    }

    const columns = [
      this.buildColumn(0),
      this.buildColumn(1, { orderable: false }),
      this.buildColumn(2),
      this.buildColumn(3, { orderable: false }),
      this.buildColumn(4, { orderable: false }),
      this.buildColumn(5, { orderable: false, searchable: false })
    ];

    const languageOptions = {
      paginate: {
        previous: "<i class='mdi mdi-chevron-left'>",
        next: "<i class='mdi mdi-chevron-right'>"
      }
    };

    if (localeUrl) {
      languageOptions.url = localeUrl;
    }

    this.dataTable = table.DataTable({
      serverSide: true,
      processing: true,
      responsive: {
        details: {
          type: 'column',
          target: 'tr'
        }
      },
      searching: false,
      stateSave: false,
      dom: 'rtp',
      ajax: {
        url: sourceUrl,
        data: (data) => {
          data.service_steps = this.filters.steps;
          data.customer = this.filters.customer;
          data.query = this.filters.query;
        },
        dataSrc: (json) => {
          if (json.error) {
            this.notifyError(json.error);
            return [];
          }
          return json.data;
        }
      },
      columns: columns,
      columnDefs: [
        {
          targets: [0, 1, 4, 5],
          responsivePriority: 1
        },
        {
          targets: [2, 3],
          responsivePriority: 2
        }
      ],
      order: [[0, 'desc']],
      language: languageOptions,
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      createdRow: (row, rowData) => {
        if (!Array.isArray(rowData)) {
          return;
        }

        $('td', row).each((index, cell) => {
          const cellData = rowData[index];
          if (!cellData || !cellData.attrs) {
            return;
          }

          Object.entries(cellData.attrs).forEach(([key, value]) => {
            $(cell).attr(key, value);
          });
        });
      },
      drawCallback: () => {
        $(".dataTables_paginate > .pagination").addClass("pagination-rounded");
        this.refreshTooltips();
      }
    });

    this.initFilters();
    this.setupEventListeners();
  }

  setupEventListeners() {
    $(document).on('click', '[data-view-history]', (e) => {
      e.preventDefault();
      const orderId = $(e.currentTarget).data('view-history');
      this.openProductHistoryModal(orderId);
    });
    
    $(document).on('click', '[data-create-incident]', (e) => {
      e.preventDefault();
      const serviceNumber = $(e.currentTarget).data('create-incident');
      this.openCreateIncidentModal(serviceNumber);
    });

    $(document).on('click', '[data-request-upgrade]', (e) => {
      e.preventDefault();
      const orderId = $(e.currentTarget).closest('tr').find('[data-view-history]').data('view-history');
      const requestType = $(e.currentTarget).data('request-type');
      this.openUpgradeRequestModal(orderId, requestType);
    });

    this.setupDateTimePickers();
  }

  initFilters() {
    if (this.step_filter) {
      this.step_filter.off('select2:select select2:unselect').on('select2:select select2:unselect', () => {
        this.filters.steps = this.step_filter.val() || [];
        this.reloadTable();
      });
    }

    $('#customer-filter').off('change').on('change', (event) => {
      const value = $(event.currentTarget).val();
      this.filters.customer = value ? value.toString() : '';
      this.reloadTable();
    });

    $("#service_customSearch").off('keyup').on('keyup', (event) => {
      const value = $(event.currentTarget).val();
      this.filters.query = value ? value.toString().trim() : '';

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.reloadTable();
      }, 300);
    });
  }

  openProductHistoryModal(orderId) {
    $('#productHistoryModal').modal('show');
    
    const baseUrl = $('#services-table').data('product-history-url');
    const url = baseUrl.replace(':id', orderId);
    
    $.ajax({
      url: url,
      method: 'GET',
      success: (response) => {
        $('#product-history-content').html(response);
        
        // Mettre à jour le numéro de service dans le titre
        const serviceNumber = $(`[data-view-history="${orderId}"]`)
          .closest('tr')
          .find('td:first code')
          .text() || 'N/A';
        $('#modal-service-number').text(`Historique des changements - ${serviceNumber}`);
      },
      error: (xhr) => {
        $('#product-history-content').html(`
          <div class="alert alert-danger">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            Erreur lors du chargement de l'historique : ${xhr.responseJSON?.error || 'Erreur inconnue'}
          </div>
        `);
      }
    });
  }

  openCreateIncidentModal(serviceNumber) {
    $('#modal_description').val(`Incident pour le service ${serviceNumber}`);
    
    const now = new Date();
    const formatted = now.toLocaleDateString('fr-FR') + ' ' + now.toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'});
    $('#modal_started_at_i').val(formatted);
    
    let serviceFound = false;
    $('#modal_service_id option').each(function() {
      const optionText = $(this).text();
      if (optionText.includes(serviceNumber)) {
        $(this).prop('selected', true);
        serviceFound = true;
        return false;
      }
    });
    
    const submitButton = $('button[form="incident_modal_form"]');
    if (!serviceFound) {
      submitButton.prop('disabled', true);
      submitButton.attr('title', 'Service introuvable');
    } else {
      submitButton.prop('disabled', false);
      submitButton.removeAttr('title');
    }
    
    if ($('#modal_incident_file').hasClass('dropify')) {
      $('#modal_incident_file').dropify('destroy');
    }
    $('#modal_incident_file').dropify({
      messages: {
        'default': 'Glissez-déposez un fichier ici ou cliquez',
        'replace': 'Glissez-déposez ou cliquez pour remplacer',
        'remove': 'Supprimer',
        'error': 'Erreur, le fichier est trop volumineux ou au mauvais format.'
      }
    });
    
    $('#createIncidentModal').modal('show');
  }
  
  openUpgradeRequestModal(orderId, requestType) {
    // Réinitialiser le formulaire
    $('#upgrade_request_form')[0].reset();
    this.pendingOptionSelection = null;
    this.optionRemovalWarningShown = false;
    this.optionAdditionWarningShown = false;
    
    // Configurer le type de demande
    $('#upgrade_request_type').val(requestType);
    $('#upgrade_requested_product_id').val('');
    
    // Mettre à jour les titres selon le type
    if (requestType === 'upgrade') {
      $('#modal-upgrade-type').html('<i class="fas fa-arrow-up text-success"></i> Mettre à niveau');
      $('#upgrade-products-title').text('Produits avec débit supérieur');
      $('#upgrade_submit_text').text('Demander l\'upgrade');
    } else {
      $('#modal-upgrade-type').html('<i class="fas fa-arrow-down text-info"></i> Downgrade');
      $('#upgrade-products-title').text('Produits avec débit inférieur');
      $('#upgrade_submit_text').text('Demander le downgrade');
    }
    
    // Récupérer les informations du service actuel
    const serviceRow = $(`[data-request-upgrade="${orderId}"]`).closest('tr');
    const serviceName = serviceRow.find('td:nth-child(2) .badge').text() || 'N/A';
    const serviceNumber = serviceRow.find('td:first code').text() || 'N/A';
    
    $('#current-service-name').text(serviceName);
    $('#current-service-unit').text(serviceNumber);
    
    const formAction = $('#services-table').data('create-upgrade-url');
    $('#upgrade_request_form').attr('action', formAction);
    $('#upgrade_request_form').data('order-id', orderId);
    
    // Charger les produits
    this.loadUpgradeProducts(orderId, requestType);
    
    // Configurer les événements du modal
    this.setupUpgradeModalEvents(orderId, requestType);
    
    // Afficher le modal
    $('#upgradeRequestModal').modal('show');
  }

  loadUpgradeProducts(orderId, requestType, page = 1, filters = {}) {
    // Persist the current selection before the cards reload via filters/pagination
    const activeProductId = $('#upgrade_requested_product_id').val();
    const selectedOptionIds = activeProductId ? this.collectSelectedOptionIds() : [];

    const params = {
      order_id: orderId,
      request_type: requestType,
      page: page,
      ...filters
    };
    
    $('#upgrade-products-container').html(`
      <div class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Chargement...</span>
        </div>
        <p class="mt-2">Chargement des produits...</p>
      </div>
    `);
    
    const url = $('#services-table').data('upgrade-products-url');
    
    $.ajax({
      url: url,
      method: 'GET',
      data: params,
      success: (response) => {
        $('#upgrade-products-container').html(response);
        if (activeProductId) {
          this.pendingOptionSelection = {
            productId: activeProductId.toString(),
            optionIds: Array.isArray(selectedOptionIds) ? [...selectedOptionIds] : []
          };
          $('#upgrade_requested_product_id').val(activeProductId);
        } else {
          this.pendingOptionSelection = null;
        }
        this.setupProductSelection();
        this.updatePagination(page);
      },
      error: (xhr) => {
        let errorMessage = 'Erreur lors du chargement des produits';
        try {
          const error = JSON.parse(xhr.responseText);
          errorMessage = error.error || errorMessage;
        } catch(e) {}
        
        $('#upgrade-products-container').html(`
          <div class="text-center py-4">
            <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
            <h6 class="text-muted">Erreur</h6>
            <p class="text-muted">${errorMessage}</p>
          </div>
        `);
      }
    });
  }

  setupUpgradeModalEvents(orderId, requestType) {
    // Gestion des filtres
    $('#upgrade_apply_filters').off('click').on('click', () => {
      const filters = {
        order_by: $('#upgrade_order_by').val(),
        filter_fas: $('#upgrade_filter_fas').val(),
        filter_subscription: $('#upgrade_filter_subscription').val()
      };
      this.loadUpgradeProducts(orderId, requestType, 1, filters);
    });
    
    // Soumission du formulaire
    $('#upgrade_submit_btn').off('click').on('click', () => {
      this.submitUpgradeRequest();
    });
    
    // Reset lors de la fermeture du modal
    $('#upgradeRequestModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
      this.resetUpgradeModal();
    });
  }

  setupProductSelection() {
    const orderId = $('#upgrade_request_form').data('order-id');
    const $cards = $('.product-card');

    // No products means the modal cannot submit
    if ($cards.length === 0) {
      $('#upgrade_submit_btn').prop('disabled', true);
      $('#upgrade_requested_product_id').val('');
      return;
    }

    const desiredProductId = $('#upgrade_requested_product_id').val();
    let $initialCard = null;

    if (desiredProductId) {
      $initialCard = $cards.filter(`[data-product-id="${desiredProductId}"]`).first();
    }

    if (!$initialCard || !$initialCard.length) {
      $initialCard = $cards.filter('[data-current="true"]').first();
    }

    if (!$initialCard || !$initialCard.length) {
      $initialCard = $cards.first();
    }

    if ($initialCard && $initialCard.length) {
      this.handleProductSelection($initialCard, orderId, true);
    }

    $('.select-product-btn').off('click').on('click', (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      const $card = $btn.closest('.product-card');
      const productId = $btn.data('product-id').toString();
      const currentSelected = $('#upgrade_requested_product_id').val();
      const forceReload = currentSelected !== productId;

      this.handleProductSelection($card, orderId, forceReload);
    });
  }

  // Switches the active product and ensures the matching options block is loaded
  handleProductSelection($card, orderId, forceReload = false) {
    if (!$card || !$card.length) {
      $('#upgrade_requested_product_id').val('');
      $('#upgrade_submit_btn').prop('disabled', true);
      this.toggleOptionsVisibility(null);
      return;
    }

    const productId = $card.data('product-id').toString();

    this.applyProductSelectionStyles($card);
    $('#upgrade_requested_product_id').val(productId);
    $('#upgrade_submit_btn').prop('disabled', false);

    if (this.pendingOptionSelection && this.pendingOptionSelection.productId !== productId) {
      this.pendingOptionSelection = null;
    }

    this.toggleOptionsVisibility($card);
    this.loadOptionsForSelectedProduct(orderId, forceReload);
  }

  getSelectedProductCard() {
    return $('.product-card.border-primary').first();
  }

  getRequestType() {
    return ($('#upgrade_request_type').val() || '').toLowerCase();
  }

  isUpgradeRequest() {
    return this.getRequestType() === 'upgrade';
  }

  isCurrentProductCard($card) {
    if (!$card || !$card.length) {
      return false;
    }

    const flag = $card.data('current');
    if (typeof flag === 'boolean') {
      return flag;
    }
    return `${flag}`.toLowerCase() === 'true';
  }

  bindOptionGuards($card) {
    if (!$card || !$card.length) {
      return;
    }

    const $inputs = $card.find('.product-options-content input.upgrade-option-checkbox');
    $inputs.off('change.option-guard');

    if (!this.isCurrentProductCard($card)) {
      return;
    }

    $inputs.on('change.option-guard', (event) => {
      const $checkbox = $(event.currentTarget);
      const requestType = this.getRequestType();
      const isCurrentOption = Boolean($checkbox.data('current-option'));

      if (requestType === 'upgrade' && isCurrentOption && !$checkbox.is(':checked')) {
        $checkbox.prop('checked', true);
        if (!this.optionRemovalWarningShown) {
          this.notifyAlert("Les options actuelles ne peuvent pas être retirées lors d'une demande d'upgrade.");
          this.optionRemovalWarningShown = true;
        }
      } else if (requestType === 'downgrade' && !isCurrentOption && $checkbox.is(':checked')) {
        $checkbox.prop('checked', false);
        if (!this.optionAdditionWarningShown) {
          this.notifyAlert("Impossible d'ajouter de nouvelles options lors d'une demande de downgrade.");
          this.optionAdditionWarningShown = true;
        }
      }
    });
  }

  // Show options below the active card while collapsing the rest
  toggleOptionsVisibility($activeCard) {
    $('.product-card').each((_, element) => {
      const $card = $(element);
      const $container = $card.find('.product-options');
      const $placeholder = $container.find('.product-options-placeholder');
      const $content = $container.find('.product-options-content');
      const isActive = $activeCard && $activeCard.length ? $card.is($activeCard) : false;

      if (isActive) {
        $placeholder.addClass('d-none');
        $content.removeClass('d-none');
        this.setCardOptionInputsState($card, true);
      } else {
        $placeholder.removeClass('d-none');
        $content.addClass('d-none');
        this.setCardOptionInputsState($card, false);
      }
    });
  }

  // Lazy-load options for the highlighted product to avoid hitting the endpoint for every card
  loadOptionsForSelectedProduct(orderId, forceReload = false) {
    const $selectedCard = this.getSelectedProductCard();
    if (!$selectedCard.length) {
      return;
    }

    if (!orderId) {
      return;
    }

    const productId = $selectedCard.data('product-id').toString();
    const $content = $selectedCard.find('.product-options-content');
    const isLoaded = $content.data('loaded') === true || $content.data('loaded') === 'true';

    let selectedOptionIds = null;
    if (this.pendingOptionSelection && this.pendingOptionSelection.productId === productId) {
      selectedOptionIds = this.pendingOptionSelection.optionIds || [];
      this.pendingOptionSelection = null;
      forceReload = true;
    }

    if (!forceReload && isLoaded) {
      this.setCardOptionInputsState($selectedCard, true);
      return;
    }

    this.setCardOptionInputsState($selectedCard, false);
    $content.html(`
      <div class="text-center py-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Chargement...</span>
        </div>
        <p class="mt-2 text-muted small">Chargement des options...</p>
      </div>
    `);
    $content.data('loaded', false);

    this.loadProductOptions(orderId, productId, selectedOptionIds);
  }

  // Fetch option partial for a given product card
  loadProductOptions(orderId, productId, selectedOptionIds = null) {
    const url = $('#services-table').data('upgrade-options-url');
    if (!url) {
      return;
    }

    const params = {
      order_id: orderId,
      product_id: productId,
      request_type: this.getRequestType()
    };

    if (selectedOptionIds !== null) {
      params.selected_option_ids_present = true;
      if (selectedOptionIds.length > 0) {
        params['selected_option_ids[]'] = selectedOptionIds;
      }
    }

    $.ajax({
      url,
      method: 'GET',
      data: params,
      success: (response) => {
        const $card = $(`.product-card[data-product-id="${productId}"]`);
        if (!$card.length) {
          return;
        }

        const $container = $card.find('.product-options-content');
        $container.html(response);
        $container.data('loaded', true);

        const isSelected = $card.hasClass('border-primary');
        this.setCardOptionInputsState($card, isSelected);
        if (isSelected) {
          $card.find('.product-options-placeholder').addClass('d-none');
          $container.removeClass('d-none');
        } else {
          $container.addClass('d-none');
          $card.find('.product-options-placeholder').removeClass('d-none');
        }
      },
      error: (xhr) => {
        const $card = $(`.product-card[data-product-id="${productId}"]`);
        if (!$card.length) {
          return;
        }

        const $container = $card.find('.product-options-content');
        let errorMessage = 'Erreur lors du chargement des options';
        try {
          const error = JSON.parse(xhr.responseText);
          errorMessage = error.error || errorMessage;
        } catch (e) {}

        $container.html(`
          <div class="text-center py-3">
            <i class="fas fa-exclamation-triangle fa-lg text-warning mb-2"></i>
            <p class="mb-0 text-muted small">${errorMessage}</p>
          </div>
        `);
        $container.data('loaded', false);
        const isSelected = $card.hasClass('border-primary');
        if (isSelected) {
          $card.find('.product-options-placeholder').addClass('d-none');
          $container.removeClass('d-none');
        } else {
          $container.addClass('d-none');
          $card.find('.product-options-placeholder').removeClass('d-none');
        }
      }
    });
  }

  // Prevent unselected cards from editing option checkboxes
  setCardOptionInputsState($card, enabled) {
    if (!$card || !$card.length) {
      return;
    }

    $card.find('.product-options-content input.upgrade-option-checkbox')
      .prop('disabled', !enabled);

    if (enabled) {
      this.bindOptionGuards($card);
    }
  }

  updatePagination(currentPage) {
    // Simple pagination pour le moment - à améliorer si nécessaire
    $('#upgrade-current-page span').text(currentPage);
    $('#upgrade-products-pagination').show();
  }

  submitUpgradeRequest() {
    const form = $('#upgrade_request_form');
    const formData = new FormData(form[0]);
    formData.append('order_id', form.data('order-id'));
    
    // Désactiver le bouton de soumission
    const submitBtn = $('#upgrade_submit_btn');
    const originalText = submitBtn.html();
    submitBtn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Envoi...');
    
    $.ajax({
      url: form.attr('action'),
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      success: (response) => {
        if (response.status === 'success') {
          $('#upgradeRequestModal').modal('hide');
          
          // Recharger la page pour mettre à jour l'état des boutons
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          this.notifyError(response.message || "Erreur lors de l'envoi de la demande");
          submitBtn.prop('disabled', false).html(originalText);
        }
      },
      error: (xhr) => {
        let errorMessage = 'Erreur lors de l\'envoi de la demande';
        try {
          const error = JSON.parse(xhr.responseText);
          errorMessage = error.message || errorMessage;
        } catch(e) {}
        
        this.notifyError(errorMessage);
        submitBtn.prop('disabled', false).html(originalText);
      }
    });
  }

  resetUpgradeModal() {
    $('#upgrade_request_form')[0].reset();
    $('#upgrade_requested_product_id').val('');
    $('.product-card').removeClass('border-primary');
    $('.select-product-btn').removeClass('btn-primary').addClass('btn-outline-primary')
      .html('<i class="fas fa-check"></i> Sélectionner');
    $('#upgrade_submit_btn').prop('disabled', true);
    $('#upgrade-products-pagination').hide();
    $('#upgrade-products-container').empty();
    $('.product-options-content').empty().data('loaded', false);
    $('.product-options-placeholder').removeClass('d-none');
    this.pendingOptionSelection = null;
    this.optionRemovalWarningShown = false;
    this.optionAdditionWarningShown = false;
  }

  collectSelectedOptionIds() {
    const ids = [];
    const $selectedCard = this.getSelectedProductCard();
    if (!$selectedCard.length) {
      return ids;
    }

    // Only persist options tied to the active product
    $selectedCard.find('.product-options-content input.upgrade-option-checkbox:checked').each((_, element) => {
      ids.push(Number.parseInt(element.value, 10));
    });
    return ids;
  }

  applyProductSelectionStyles($card) {
    $('.product-card').removeClass('border-primary');
    $('.product-card .select-product-btn')
      .removeClass('btn-primary')
      .addClass('btn-outline-primary')
      .html('<i class="fas fa-check"></i> Sélectionner');

    if (!$card || $card.length === 0) {
      $('#upgrade_requested_product_id').val('');
      $('#upgrade_submit_btn').prop('disabled', true);
      return;
    }

    $card.addClass('border-primary');
    const $button = $card.find('.select-product-btn');
    $button.removeClass('btn-outline-primary')
      .addClass('btn-primary')
      .html('<i class="fas fa-check-circle"></i> Sélectionné');
  }

  reloadTable(resetPaging = true) {
    if (!this.dataTable) {
      return;
    }

    this.dataTable.ajax.reload(null, resetPaging);
  }

  refreshTooltips() {
    $('[data-toggle="tooltip"]').each(function() {
      const $element = $(this);
      $element.tooltip('dispose');
      $element.tooltip({ trigger: 'hover' });
    });
  }

  buildColumn(index, options = {}) {
    const column = {
      data: (row) => (Array.isArray(row) ? row[index] || null : null),
      render: (cellData, type) => this.renderCell(cellData, type)
    };

    if (options.orderable === false) {
      column.orderable = false;
    }

    if (options.searchable === false) {
      column.searchable = false;
    }

    return column;
  }

  renderCell(cellData, type) {
    if (!cellData) {
      return '';
    }

    if (type === 'sort') {
      if (cellData.attrs && cellData.attrs['data-order']) {
        return cellData.attrs['data-order'];
      }
      return this.extractTextFromHtml(cellData.html);
    }

    if (type === 'filter') {
      return this.extractTextFromHtml(cellData.html);
    }

    return cellData.html;
  }

  extractTextFromHtml(html) {
    if (!html) {
      return '';
    }

    const container = document.createElement('div');
    container.innerHTML = html;
    return container.textContent || '';
  }

  setupDateTimePickers() {
    flatpickr('#modal_started_at_i', {
      enableTime: true,
      dateFormat: "d/m/Y H:i",
      time_24hr: true,
      locale: "fr",
      defaultDate: new Date(),
      allowInput: true
    });
  }

  notifyError(message) {
    if (!message) {
      return;
    }
    if (window.application && typeof window.application.errorNotification === 'function') {
      window.application.errorNotification(message);
    }
  }

  notifyAlert(message) {
    if (!message) {
      return;
    }
    if (window.application && typeof window.application.alertNotification === 'function') {
      window.application.alertNotification(message);
    } else if (window.application && typeof window.application.noticeNotification === 'function') {
      window.application.noticeNotification(message);
    }
  }

  onDestroy() {
    if (this.step_filter) {
      this.step_filter.select2('destroy');
    }

    if (this.dataTable) {
      this.dataTable.destroy();
    }

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    
    // Nettoyer flatpickr comme dans ExtranetIncidentsIndex
    $("#modal_started_at_i").each(function() {
      if (this._flatpickr) {
        this._flatpickr.destroy();
      }
    });
    
    // Nettoyer dropify
    if ($('#modal_incident_file').hasClass('dropify')) {
      $('#modal_incident_file').dropify('destroy');
    }
    
    // Nettoyer les événements du modal d'upgrade
    $('#upgradeRequestModal').off('hidden.bs.modal');
    $('#upgrade_apply_filters').off('click');
    $('#upgrade_submit_btn').off('click');
    $('.select-product-btn').off('click');
  }
}